import React from "react";
import { useNavigate } from "react-router-dom";
import { money, COURSE_IMAGES } from "../lib/data";
import { Check, Crown, ArrowRight } from "lucide-react";

export function CourseCard({ course, index }) {
  const navigate = useNavigate();
  const flagship = course.mentorship;
  return (
    <div
      className={`group bg-white border ${flagship ? "border-[#D4AF37]" : "border-gray-200"} flex flex-col fade-up`}
      style={{ animationDelay: `${index * 60}ms` }}
      data-testid={`course-card-${course.id}`}
    >
      <div className="relative h-44 overflow-hidden bg-[#0A1914]">
        <img src={COURSE_IMAGES[course.id]} alt={course.title} className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute top-0 left-0 bg-[#0A1914] text-white text-xs font-mono px-3 py-1.5">
          LEVEL {course.level}
        </div>
        {flagship && (
          <div className="absolute top-0 right-0 bg-[#D4AF37] text-[#0A1914] text-xs font-mono px-3 py-1.5 flex items-center gap-1">
            <Crown className="h-3 w-3" /> FLAGSHIP
          </div>
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <p className="font-mono text-xs uppercase tracking-widest text-[#00B368] mb-2">{course.market}</p>
        <h3 className="font-display text-2xl leading-tight text-[#0A1914] mb-2">{course.title}</h3>
        <p className="text-sm text-gray-600 mb-4 flex-1">{course.tagline}</p>
        <div className="flex items-end justify-between mb-4">
          <div>
            <p className="font-mono text-3xl text-[#0A1914]">{money(course.price)}</p>
            <p className="text-xs text-gray-500">one-time · Bitcoin</p>
          </div>
          <div className="text-right">
            <p className="font-mono text-lg text-[#00B368]">{money(course.weekly)}/wk</p>
            <p className="text-xs text-gray-500">paid for 52 weeks</p>
          </div>
        </div>
        <div className="border-t border-gray-100 pt-4 mb-4 space-y-1.5">
          {course.modules.slice(0, 3).map((m) => (
            <div key={m} className="flex items-start gap-2 text-xs text-gray-600">
              <Check className="h-3.5 w-3.5 text-[#00B368] mt-0.5 shrink-0" /> {m}
            </div>
          ))}
        </div>
        <button
          onClick={() => navigate(`/checkout/${course.id}`)}
          data-testid={`enroll-btn-${course.id}`}
          className={`w-full flex items-center justify-center gap-2 py-3 text-sm font-medium rounded-sm transition-colors duration-300 ${flagship ? "bg-[#D4AF37] text-[#0A1914] hover:bg-[#0A1914] hover:text-white" : "bg-[#0A1914] text-white hover:bg-[#00B368]"}`}
        >
          Enroll with Bitcoin <ArrowRight className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
